import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Router from '@/router';
import '@/styles/main.scss';

import { initAnalytics } from '@/utils/analytics';
import { initSentry } from '@/utils/sentry';
// 兼容低端机var不识别
import 'antd-mobile/bundle/css-vars-patch.css';
import 'uno.css';
// import '@/styles/tiechu/theme.css';
import { AliveScope } from 'react-activation';
import { report, EVENTTYPES } from '@/utils/analytics';
import { useCookie } from '@/hooks/useCookie';
import { cookieUnionIdKey } from '@/config';

initSentry();
initAnalytics();

const container = document.getElementById('root')!;

const App = () => {
  const { getCookie } = useCookie();

  useEffect(() => {
    const isWxAuthPageShow = sessionStorage.getItem('wx_auth_page_show');
    const cookieUnionId = getCookie(cookieUnionIdKey);

    if (isWxAuthPageShow) {
      // 有微信授权标识则清空
      sessionStorage.removeItem('wx_auth_page_show');
      // 微信授权 session 标识，cookie unionId 都存在则上报成功
      if (cookieUnionId) {
        report({
          event_type: EVENTTYPES.PAGE_SHOW,
          event_id: 'wx_auth_success',
        });
      }
    }
  }, [getCookie]);

  return (
    <BrowserRouter basename='/mweb'>
      <AliveScope>
        <Router />
      </AliveScope>
    </BrowserRouter>
  )
}

// 运行时兜底：优先 hydrateRoot → 再 createRoot → 最后 ReactDOM.render
// try {
//   const hydrateRoot = (ReactDOMClient as any)?.hydrateRoot;
//   const createRoot = (ReactDOMClient as any)?.createRoot;

//   if (container.hasChildNodes() && typeof hydrateRoot === 'function') {
//     hydrateRoot(container, app);
//   } else if (typeof createRoot === 'function') {
//     createRoot(container).render(app);
//   } else if (typeof (ReactDOM as any).render === 'function') {
//     // 旧浏览器/旧导出下使用 ReactDOM.render 兜底
//     (ReactDOM as any).render(app, container);
//   } else {
//     // 万一三个都拿不到，抛错提示
//     throw new Error('No available React render method (hydrateRoot/createRoot/render)');
//   }
// } catch (e: any) {
//   alert('React 渲染失败: ' + (e?.message || e));
//   // 最后再尝试一次最老 API
//   try {
//     (ReactDOM as any).render?.(app, container);
//   } catch {}
// }

ReactDOM.render(<App />, container);
